const breakfast = [
    {
        item: "Breakfast Burrito",
        ingredients: "3 eggs, hash brown, onions, bell peppers, cheese, & choice of bacon, chorizo, ham, or sausage"
    },
    {
        item: "Breakfast Sandwich",
        ingredients: "3 eggs, lettuce, tomato, mayo, cheese, & choice of bacon, ham, or sausage"
    },
    {
        item: "French Toast Sandwich",
        ingredients: "2 slices of french toast, 3 eggs, cheese, hash brown, & choice of bacon, ham, or sausage"
    },
    {
        item: "Spicy Breakfast Melt",
        ingredients: "Beef patty, 2 eggs, tomato, jalapeno, mayo, mustard, cheese"
    },
    {
        item: "Steak & Egg Sandwich",
        ingredients: "french roll w/ 2 eggs, mayo, grilled onion"
    },
]

export default breakfast